import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import * as styles from './styles.css';

export function SectionOfQuestions() {
  return (
    <div className={styles['container']}>
      <div className={styles['items']}>
        <div {...mergeStyles(styles['item'], styles['item-home-bg'])}>
          <span className={styles['overlay']} />
          <div className={styles['content']}>
            <div className={styles['title']}>Продавцу</div>
            <div className={styles['text']}>Назначте объективную цену и повысьте спрос, не теряя выгоды</div>
          </div>
        </div>
        <div {...mergeStyles(styles['item'], styles['item-key-bg'])}>
          <div className={styles['overlay']} />
          <div className={styles['content']}>
            <div className={styles['title']}>Покупателю</div>
            <div className={styles['text']}>
              Узнайте рыночную стоимость, чтобы аргументированно торговаться с продавцом
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
